<script>
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [apigeneric],
  data() {
    return {
      NewsData: {},
      Created: ""
    };
  },
  components: {},
  methods: {
    getFirstImage(gallery) {
      if (gallery) {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "3",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "News",
        Page: Page,
        Filter:
          "&Asc=Startdate" + 
          "&Newstype=2&Websiteid=" +
          window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NewsData = res.Data;
      });

     


     

      
    },
  },
};
</script>

<template>
  <section>
    <div class="home-news">
      <div class="title c-flex flex-column">
        <a :href="'/fullnews/tr'" class="card-link"><h3>{{$t("dashboards.NewsTitle")}}</h3></a>
        <p>{{$t("dashboards.NewsDescription")}}</p>
      </div>
      <div class="container">
        <div class="row">
          <div
            class="col-md-4 c-flex"
            v-for="(Data, index) in NewsData"
            :key="index"
          >
            <div class="card">
              <img
                :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)"
                class="card-img-top"
                alt=""
              />
              <div class="card-body">
                <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                <h5 class="card-title mt-3">
                  {{ Data.Title }}
                </h5>
                <p class="card-text">
                  <span v-html="Data.Description"></span><br />
                </p>
                <a :href="'/NewsDetail/tr/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id" class="card-link"
                  > {{$t("OrtakKullanim.ReadMore")}} →</a
                >
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
